<template>
  <div>
    <StaticContent v-if="isConversa" data-cy="conversa" resource="conversa" />
    <StaticContent v-else data-cy="sin_conversa" resource="sin_conversa" />
  </div>
</template>

<script>
import StaticContent from 'components/StaticContent.vue'

export default {
  name: 'conversa-banner-vue',
  components: { StaticContent },
  props: {
    isConversa: { type: Boolean, default: false },
  }
}
</script>
